import { render, staticRenderFns } from "./DDSCardModal.vue?vue&type=template&id=6f34d66a&scoped=true"
import script from "./DDSCardModal.vue?vue&type=script&lang=js"
export * from "./DDSCardModal.vue?vue&type=script&lang=js"
import style0 from "./DDSCardModal.vue?vue&type=style&index=0&id=6f34d66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34d66a",
  null
  
)

export default component.exports